import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import {atomIconSizes} from '@s-ui/react-atom-icon'
import IconBookmarkOutlinePlus from '@adv-mt/mt-svg-icons/lib/BookmarkOutlinePlus'
import IconBookmarkSolid from '@adv-mt/mt-svg-icons/lib/BookmarkSolid'

const BASE_CLASS = 'mt-ActionsSaveNews'

const ActionSaveNewsButton = ({
  isMarked,
  onClick,
  className,
  iconSize,
  showLabel = false,
  size = atomButtonSizes.SMALL
}) => (
  <div className={`${BASE_CLASS} ${className || ''}`}>
    <AtomButton
      leftIcon={
        isMarked ? (
          <IconBookmarkSolid size={iconSize || atomIconSizes.medium} />
        ) : (
          <IconBookmarkOutlinePlus size={iconSize || atomIconSizes.medium} />
        )
      }
      onClick={onClick}
      aria-checked={isMarked}
      design={atomButtonDesigns.SOLID}
      color={atomButtonColors.PRIMARY}
      shape={atomButtonShapes.CIRCULAR}
      isFitted
      negative
      aria-label={isMarked ? 'Guardado' : 'Guardar'}
      role="checkbox"
      size={size}
    >
      {showLabel && (isMarked ? 'Guardada' : 'Guardar')}
    </AtomButton>
  </div>
)

ActionSaveNewsButton.displayName = 'ActionSaveNewsButton'
ActionSaveNewsButton.propTypes = {
  className: PropTypes.string,
  isMarked: PropTypes.bool,
  onClick: PropTypes.func,
  iconSize: PropTypes.string,
  showLabel: PropTypes.bool,
  size: PropTypes.string
}

export default ActionSaveNewsButton
